import { Fragment } from 'react'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import './ScenarioButtonsGroups.scss'
import { mergeClassNames } from '../../../../../utils/commonFunctions'

interface GroupButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    show?: boolean
    children: React.ReactNode
    className?: string
    disabled?: boolean
    onClick: () => void
    label: string
    active?: boolean
}

const GroupButton: React.FC<GroupButtonProps> = ({ children, className = '', active = false, disabled, onClick, label, show = true, ...props }) => {
    if (!show) return null
    return (
        <Fragment>
            <CustomToolTip title={label}>
                <button className={mergeClassNames(`group__button ${active && 'active'}`, className)}
                    disabled={disabled}
                    onClick={onClick}
                    {...props}
                >
                    {children}
                </button>
            </CustomToolTip>
        </Fragment>
    )
}

export default GroupButton